import 'nprogress/nprogress.css'
import axios from 'axios'
let appConfigs = require(`../assets/client/${process.env.CLIENTID}/site_config.json`)

// import NProgress from 'nprogress'
// import UIkit from 'uikit'
// import store from '../store'

// import Hub from '../events/Hub'
/**
 * Creates a new instance of Axios configured with Base MZ connect configuration.
 * @type {AxiosInstance}
 */
export const MZCAPI = axios.create({
  baseURL: appConfigs.api_url
})

// before a request is made start the nprogress
MZCAPI.interceptors.request.use(config => {
  // console.log('int working')
  // store.dispatch('setAjaxProgress', true)

  // Disabling as we don't need to show we are fetching user progress
  // NProgress.start()

  // let url = config.url
  // console.log(config.url)
  // console.log(url.includes('/consumer/login'))
  // if (!store.getters.isInitialAjaxDone && !url.includes('/consumer/login')) {
  //   UIkit.modal('#modal-full').show()
  // }
  return config
})

// before a response is returned stop nprogress
MZCAPI.interceptors.response.use(response => {
  // console.log('int done')
  // store.dispatch('setAjaxProgress', false)

  // Disabling as we don't need to show we are fetching user progress
  // NProgress.done()

  // if (!store.getters.isInitialAjaxDone) {
  //   store.dispatch('initialAjaxDone')
  //   UIkit.modal('#modal-full').hide()
  // }
  return response
}, function (error) {
  // console.log('error http')
  // if (error.response.status === 401) {
  //   UIkit.notification({message: 'Login Error', status: 'success'})
  // }
  // store.dispatch('setAjaxProgress', false)
  // NProgress.done()
  return Promise.reject(error.response)
})



// WEBPACK FOOTER //
// ./src/helpers/http-mzcapi.js